import axiosInstance from "./BaseService";
import { cacheGet, cacheSet } from "../utils/cacheUtil";

// Cache keys
const CACHE_KEYS = {
  SITE_CONFIG: 'site_config',
  BASIC_HOME_CONTENT: 'basic_home_content'
};

// TTL in seconds (6 hours = 21600 seconds)
const CACHE_TTL = 21600;

// Get site configuration
export const fetchSiteConfig = async () => {
  // Try to get from cache first
  const cachedData = await cacheGet(CACHE_KEYS.SITE_CONFIG);
  if (cachedData) {
    return cachedData;
  }
  
  // If not in cache, fetch from API
  const response = await axiosInstance.get('/site-config');
  const data = response.data;
  
  // Store in cache
  await cacheSet(CACHE_KEYS.SITE_CONFIG, data, CACHE_TTL);
  
  return data;
};

// Update site configuration
export const updateSiteConfig = async (configData: any) => {
  const response = await axiosInstance.put('/site-config', configData);
  const data = response.data;
  
  // Update cache with new data
  await cacheSet(CACHE_KEYS.SITE_CONFIG, data, CACHE_TTL);
  
  return data;
};

// Get content for basic home page
export const fetchBasicHomeContent = async () => {
  // Try to get from cache first
  const cachedData = await cacheGet(CACHE_KEYS.BASIC_HOME_CONTENT);
  if (cachedData) {
    return cachedData;
  }
  
  // If not in cache, fetch from API
  const response = await axiosInstance.get('/site-config/basic-home-content');
  const data = response.data;
  
  // Store in cache
  await cacheSet(CACHE_KEYS.BASIC_HOME_CONTENT, data, CACHE_TTL);
  
  return data;
};

// Send global push notification
export const sendGlobalNotification = async (notificationData: { title: string; body: string; data?: any }) => {
  const response = await axiosInstance.post('/site-config/global-notification', notificationData);
  return response.data;
};